export const COMPANY_NAME = "Wehear"

export const companyDetails = {
    NAME: "Wehear",
    EMAIL: "",
    ADDRESS: '',
    GST: "",
    bankName: "",
    bankIFSC: "",
    bankNo: "",
    companyName: COMPANY_NAME

}
export const THIRD_PART_APPS_USED = {
    none: "none",
}
export const USER_ROLES = {
    ADMIN: 1,
    SIT_MANAGER: 2,
    SIT_TEAM: 3,
    // CAMP_COORDINATOR: 14
}
export const NOTIFICATION_TYPE = {
    general: "general",

}
export const PRODUCT_CATEGORY = {
    LIFESTYLE: 1,
    HEARING_AID: 2
};
export const SNACK_BAR_VARIETNS = {
    error: "error",
    suceess: "success",
    warning: "warning"
}


export const actions = {
    'SIGN_IN': 'SIGN_IN',
    'SET_USER': 'SET_USER',
    SIGN_OUT: "SIGN_OUT",
    OPEN_MODAL: 'OPEN_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL',

    SET_LIFE_STOCK_DATA: "SET_LIFE_STOCK_DATA",
    START_LIFE_STOCK_LOADING: 'START_LIFE_STOCK_LOADING',

    SET_LEAVE_BALANCE_COUNT_DATA: "SET_LEAVE_BALANCE_COUNT_DATA",
    START_LEAVE_BALANCE_COUNT_LOADING: 'START_LEAVE_BALANCE_COUNT_LOADING',


    SET_HOLIDAY_COUNT_DATA: "SET_HOLIDAY_COUNT_DATA",
    START_HOLIDAY_COUNT_LOADING: 'START_HOLIDAY_COUNT_LOADING',

    SET_NOTIFICATION_DATA: 'SET_NOTIFICATION_DATA',
    NOTIFICATION_READ: 'NOTIFICATION_READ',


    CALL_SNACKBAR_DATA: 'CALL_SNACKBAR_DATA',


    SET_DEVICES_LIST: 'SET_DEVICES_LIST',
    UPDATE_DEVICES_LIST: "UPDATE_DEVICES_LIST",

    SET_OSCILLA_PATIENT_DETAILS: "SET_OSCILLA_PATIENT_DETAILS",
    TEST_OSCILLA_PATIENT_DETAILS: "TEST_OSCILLA_PATIENT_DETAILS",
    START_OSCILLA_LOADING_VALUES: "START_OSCILLA_LOADING_VALUES",
    SET_LOADING:"SET_LOADING"
}

export const DATE_TIME_FILTERS = {

    this_week: "This Week",
    this_month: "This Month",
    this_year: "This Year",
    last_month: "Last Month",
    last_year: "Last Year",
    last_week: "Last Week",
    today: "Today",
    yesterday: "Yesterday"

}

export const REGIONS_TYPE = {
    COUNTRY: 1,
    STATE: 2,
    DISTRICT: 3,
    TALUKA: 4,
};
export const DEVICES = {
    BTE_OPTIMA: 1,
    BTE_PRIME: 2,
    RIC_OPTIMA: 6,
    RIC_OPTIMA_8: 8,
    ITE_OPTIMA: 9,
    // POWER_BTE: 10,
    RIC_32: 11,
    ITE_PRIME: 12,
    NECKBAND: 13,

    WEHEAR_OX: 14,
    SAFE_BUDS: 15,
    // SAFE_HEADPHONE: 16,
    WEHEAR_2_0: 17
};

export const LEVEL_OF_HEARING_LOSS = {
    NORMAL: 1,
    MILD: 2,
    MODERATE: 3,
    MODERATE_SEVERE: 4,
    SEVERE: 5,
    PROFOUND: 6,
};

export const GENDER = {
    MALE: 1,
    FEMALE: 2,
    OTHER: 3
}


export const DRUM = {
    INTACT: 1,
    PERFORATED: 2,
    DULL: 3,
    // RETRACTED: 4,
    OTHER: 4,
}

export const WAX = {
    NO_CERUMEN: 1,
    IMPACTED_CERUMEN: 2,
    PERIPHERAL_WAX: 3,
    OTORRHEA: 4,
    OTOMYCOSIS: 5,
    // OTHER: 6
}

export const DEVICES_NAME = {
    1: "BTE OPTIMA",
    2: "BTE PRIME",
    // 3: "GLASSES",
    // 4: "BTE 32",
    // 5: "BTE 24",
    6: "RIC OPTIMA 16",
    // 7: "RIC PRIME",
    8: "RIC OPTIMA 8",
    9: "ITE OPTIMA",
    10: "POWER BTE",
    11: "RIC OPTIMA 32",
    12: "ITE PRIME",
    13: "NECKBAND",

    14: "WEHEAR OX",
    15: "SAFE BUDS",
    17: "WEHEAR 2.0"
};